<template>
  <file-pond
    ref="pond"
    :class="{ 'forceWhite': whiteBG }"
    :name="uploadType"
    :accepted-file-types="fileTypes"
    :credits="null"
    :label-idle="labelText"
    :allow-multiple="false"
    :files="existingFile"
    :server="server"
    @addfile="fileAdded"
    @processfile="finishedUpload"
  />
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "@/assets/filePond.scss"; // override some styles, using whiteBG prop
// image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
// import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// import FilePondPluginImageCrop from "filepond-plugin-image-crop";
// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  // FilePondPluginImagePreview,
  // FilePondPluginImageCrop
);

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import { mapState } from "vuex";

import { references, db } from '@/main';

export default {
  name: "upload",
  components: {
    FilePond
  },
  props: {
    whiteBG: {
      type: Boolean,
      default: false
    },
    uploadType: {
      type: String,
      required: true
    },
    labelText: {
      type: String,
      required: true
    },
    fileTypes: {
      type: String,
      required: true
    },
    existingFile: {
      // not working. to display previews, you must have a local file only
      type: String,
      required: false
    },
    forUser: {
      // when setting a profile picture for a user
      type: String,
      required: false
    }
  },
  data() {
    return {
      // server: {
      //   url: 'http://localhost:5001/aceso-webflow-project/us-central1/fireExpress/api', // local
      //   // url: 'https://us-central1-aceso-webflow-project.cloudfunctions.net/fireExpress/api', // prod
      //   process: {
      //     url: "/test",
      //     method: 'POST',
      //     headers: {
      //       "Authorization": null,
      //       "X-Upload-Type": null,
      //       "X-For-User": null, // optional, may be null
      //     },
      //     withCredentials: false,
      //   }
      // }
    };
  },
  computed: {
    server: {
      get() {
        let uploadTask; // needs to be accessed from abort() in the return statement as well as process()
        return {
          process: async (fieldName, file, metadata, load, error, progress, abort) => {

            //******** UPLOAD FILE ********//
            // fieldName is also the category: VIDEO_INTRO, PROFILE_PICTURES, PRACTICE_LOGO, VIDEO_OUTRO, FACEBOOK_IMAGES
            const storage = firebase.storage().ref();
            const fileExt = file.name.split('.').pop();
            const practiceID = this.practice.practice_id;
            let ref = `practices/${practiceID}/${fieldName}`;
            if (fieldName === 'PROFILE_PICTURES') { // profile pictures are in a directory, while everything else is a /practices/file.ext reference
              ref = `${ref}/${this.forUser}.${fileExt}`
            } else if (fieldName === 'FACEBOOK_IMAGES') {
              // console.log('got it');
              const sanitizedName = file.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              ref = `${ref}/${sanitizedName}`;
            } else {
              ref = `${ref}.${fileExt}`;
            }
            uploadTask = storage.child(ref).put(file, metadata);

            uploadTask.on('state_changed', 
              (snapshot) => {
                progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused');
                    break;
                  // case firebase.storage.TaskState.RUNNING: // or 'running'
                  //   console.log('Upload is running');
                  //   break;
                }
              },
              (err) => {
                // Handle unsuccessful uploads
                console.log('failed')
                console.log(err)
                error('Failed!');
              }, 
              () => { // handle successful uploads
                //******** UPDATE FIRESTORE REFERENCES ********//
                uploadTask.snapshot.ref.getDownloadURL().then(async() => { // download url is passed here, but removed since we never need it
                  // TODO: make a call to the backend to make public, using the url
                  // NVM: made the entire bucket public, no need to change any permissions
                  try {
                    const practicePath = `${references.practice}/${practiceID}`;
                    let users, findUser;
                    ref = `https://storage.googleapis.com/aceso-webflow-project.appspot.com/${ref}`;
                    switch(this.uploadType) {
                      case('PROFILE_PICTURES'):
                        users = JSON.parse(JSON.stringify(this.users)); // force pass by value so we don't change vuex data
                        findUser = users.filter(o => o.uid === this.forUser)[0]; // filter returns a single item array
                        // find array index for the correct user
                        users[users.indexOf(findUser)].profile_pic = ref;
                        // update in user's doc
                        await db.collection(references.user).doc(this.forUser).update({ profile_pic: ref });
                        // update practice.users array
                        await db.collection(references.practice).doc(practiceID).set({ users }, { merge: true });
                        break
                      case('PRACTICE_LOGO'):
                        await db.doc(practicePath).set({ practice_logo: ref }, { merge: true })
                        break
                      case('VIDEO_INTRO'):
                        await db.doc(practicePath).set({ video_intro: ref }, { merge: true })
                        break
                      case('VIDEO_OUTRO'):
                        await db.doc(practicePath).set({ video_outro: ref }, { merge: true })
                        break
                      case('FACEBOOK_IMAGES'):
                        console.log('updating ref for facebook images')
                        // await db.doc(practicePath).update({
                        //   facebook_images: firebase.firestore.FieldValue.arrayUnion({ src: ref })
                        // }, { merge: true })
                        await db.doc(practicePath).update({ facebook_images: { src: ref } }, { merge: true });
                        break
                    }
                  } catch(err) {
                    console.log(err);
                  }
                  // await db.collection(references.user)
                  load('success');
                  // console.log('File available at', downloadURL);
                });
              }
            );
            return {
              abort: () => { // This function is entered if the user has tapped the cancel button
                uploadTask.cancel();
                console.log('cancelled');
                abort(); // Let FilePond know the request has been cancelled
              }
            };
          }
        };
      }
    },
    ...mapState({
      ready: state => state.auth.isReady,
      practice: state => state.auth.practice,
      users: state => state.auth.practice.users,
    })
  },
  methods: {
    finishedUpload() {
      // console.log("Finished upload!");
      if (this.uploadType === 'VIDEO_INTRO' || this.uploadType === 'VIDEO_OUTRO') {
        this.$root.$emit('uploaded_video');
      } else if (this.uploadType === 'PROFILE_PICTURES') {
        this.$root.$emit('uploaded_profile_pic');
      } else {
        this.$root.$emit('uploaded_practice_logo');
      }
    },
    async fileAdded() {
      // when a file is added, update the POST information
      // if (this.ready) {
      //   // wait for currentUser to have value
      //   const token = await firebase.auth().currentUser.getIdToken(false);
      //   this.server.process.headers.Authorization = `Bearer ${token}`;
      //   this.server.process.headers["X-Upload-Type"] = this.uploadType;
      //   this.server.process.headers["X-For-User"] = this.forUser; // for pfp, may be null
      // }
      return
    }
  }
};
</script>
